import React, { Component } from "react";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { ResidentsActions, SuperAdminAction } from "../../Actions";
import CustomContentAlert, {
  routing_using_history,
  // isEmailValid,
  validation_message,
  validations,
  regExForPhone,
  PasswordValidation,
} from "../helper";

class EditResident extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editedResident: null,
      ResidentId: this.props.location.search.split("?")[1]
        ? this.props.location.search.split("?")[1]
        : "",
      suite_id: "",
      parking_spot: "",
      permits_allowed: "",
      username: "",
      first_name: "",
      last_name: "",
      country_code: "",
      phone: "",
      // email: "",
      do_not_allow_login: false,
      password: "",
      user_type: "",
      isFormValid: false,
      validSuiteId: true,
      validParkingSpot: true,
      validFirstName: true,
      validLastName: true,
      validPhone: true,
      // validEmail: true,
      validPermitAllowed: true,
      validUser: true,
      show_alert: false,
      api_success_message: "",
      api_error_message: "",
      show_error: false,
      property: this.props.property,
      phoneErrorMessage: "",
      passwordErrorMsg: "",
      passwordVisible: false,
      country_code_list: [
        { text: "+1", value: "+1" },
        { text: "+91", value: "+91" },
        { text: "+44", value: "+44" },
        { text: "+61", value: "+61" },
      ],
      // phone_options: [],
      deleted_phone_id: [],
    };
  }

  componentDidMount = async () => {
    // for edit resident details
    // const { PropertyId, ResidentId } = this.state;
    const { ResidentId } = this.state;
    // this.props.select_edit_resident(PropertyId, ResidentId).then(() => {
    await this.props.select_edit_resident(ResidentId);
    const selectedPropertyName = this.state.property?.property_name;
    const selectedDomainName = this.state.property?.domain;
    this.props.setDomainHeader(selectedPropertyName, selectedDomainName);

    this.setState(
      { editedResident: this.props.editedResident, isFormValid: true },
      () => {
        this.settingData();
      }
    );
    this.settingData();
  };

  settingData = () => {
    const { editedResident } = this.state;
    if (editedResident) {
      const {
        suite_id,
        parking_spot,
        permits_allowed,
        username,
        first_name,
        last_name,
        country_code,
        phone,
        email,
        do_not_allow_login,
        // password,
        user_type,
        phone_options,
      } = editedResident;
      console.log("Phone Options front side::::", phone_options);
      this.setState({
        suite_id,
        parking_spot,
        permits_allowed,
        username,
        first_name,
        last_name,
        country_code,
        phone,
        email,
        do_not_allow_login,
        // password,
        user_type,
        phone_options,
      });
    }
  };

  handlePhoneOptions = (index, value, type) => {
    console.log("index, value :::::", index, value, type);
    const { phone_options } = this.state;
    console.log("phone_options:::", phone_options);

    let phone_values;
    let country_code_values;

    if (type === "phone_number_options") {
      phone_values = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      phone_options[index].phone = phone_values;
    }
    if (type === "country_code_options") {
      country_code_values = value;
      phone_options[index].country_code = country_code_values;
    }

    this.setState(
      {
        phone_options: [...phone_options],
      },
      async () => {
        this.handlephoneOptionValidation();
      }
    );

    console.log("phone_options::::", phone_options);
  };

  removePhoneOption = (index) => {
    const { phone_options, deleted_phone_id } = this.state;
    console.log("index", index);

    const deleted_ID = phone_options[index];

    console.log("deleted_ID:::", deleted_ID.id);

    this.setState(
      {
        phone_options: [...phone_options.filter((_x, i) => i !== index)],
      },
      async () => {
        if (deleted_ID.id) {
          this.setState({
            deleted_phone_id: [...deleted_phone_id, deleted_ID],
          });
        }
        this.handlephoneOptionValidation();
      }
    );
  };

  handleAddPhoneOptions = () => {
    console.log("handleAddPhoneOptions called::---");
    const { phone_options } = this.state;

    this.setState(
      {
        phone_options: [...phone_options, { country_code: "+1", phone: "" }],
      },
      async () => {
        this.handlephoneOptionValidation();
      }
    );
  };

  handlephoneOptionValidation = () => {
    const {
      first_name,
      last_name,
      phone,
      password,
      username,
      permits_allowed,
    } = this.state;
    let isValidPhone = true;
    let passwordValue = 1;
    const high_security = this.props.property.high_security;
    if ((phone && phone.length >= 11) || (phone && phone.length < 10)) {
      this.setState({
        phoneErrorMessage: "Please enter valid phone number",
      });
      isValidPhone = false;
    } else {
      this.setState({
        phoneErrorMessage: "",
      });
    }

    if (high_security) {
      const errMsg = PasswordValidation(password);
      this.setState({
        passwordErrorMsg: errMsg,
      });
      if (errMsg) {
        passwordValue = false;
        this.setState({
          passwordErrorMsg: errMsg,
        });
      } else {
        passwordValue = true;
        this.setState({
          passwordErrorMsg: "",
        });
      }
    }
    console.log(
      "this.isMultiplePhoneValid::::onAddd====",
      this.isMultiplePhoneValid()
    );
    this.checkAllValidations(
      phone,
      username,
      first_name,
      last_name,
      permits_allowed,
      isValidPhone,
      passwordValue
    );
  };

  isMultiplePhoneValid = () => {
    const { phone_options } = this.state;

    const validPhone = phone_options.map((options) => {
      if (
        options.phone?.trim().length > 10 ||
        options.phone?.trim().length < 10 ||
        options.phone?.trim().length === 0
      ) {
        return !(
          options.phone.trim().length > 10 ||
          options.phone.trim().length < 10 ||
          options.phone.trim().length === 0
        );
      }
      return true;
    });
    console.log("validPhone:::", validPhone);
    return !validPhone.includes(false);
  };

  handleChange = ({ target }) => {
    const prevstate = this.state.phone;
    const high_security = this.props.property.high_security;
    const passwordValue = 1;
    this.setState(
      {
        [target.name]: target.value,
      },
      async () => {
        const {
          country_code,
          phone,
          // email,
          first_name,
          last_name,
          username,
          permits_allowed,
        } = this.state;
        this.handleOnchangeCountryCodeAndPhone(
          target,
          prevstate,
          phone,
          country_code
        );

        const FirstName = validations(
          target.name,
          "first_name",
          this.state.first_name
        );
        this.setState({
          first_name: FirstName.value,
          validFirstName: FirstName.validator,
        });

        const LastName = validations(
          target.name,
          "last_name",
          this.state.last_name
        );
        this.setState({
          last_name: LastName.value,
          validLastName: LastName.validator,
        });

        const Phone = validations(target.name, "phone", this.state.phone);
        this.setState({
          phone: Phone.value,
          validPhone: Phone.validator,
        });

        const PermitsAllowed = validations(
          target.name,
          "permits_allowed",
          this.state.permits_allowed
        );
        console.log("PermitsAllowedPermitsAllowed", PermitsAllowed);
        this.setState({
          permits_allowed: PermitsAllowed.value
            .toString()
            .replace(/[^0-9 ]/g, ""),
          validPermitAllowed: PermitsAllowed.validator,
        });

        const UserName = validations(
          target.name,
          "username",
          this.state.username
        );
        this.setState({
          username: UserName.value,
          validUser: UserName.validator,
        });

        const passwordValues = this.handleOnchangePassword(
          target,
          high_security,
          passwordValue
        );

        this.setState(() => {
          let isValidPhone = true;
          if ((phone && phone.length >= 11) || (phone && phone.length < 10)) {
            this.setState({
              phoneErrorMessage: "Please enter valid phone number",
            });
            isValidPhone = false;
          } else {
            this.setState({
              phoneErrorMessage: "",
            });
          }
          this.checkAllValidations(
            phone,
            username,
            first_name,
            last_name,
            permits_allowed,
            isValidPhone,
            passwordValues
          );
        });
      }
    );
  };

  handleOnchangeCountryCodeAndPhone = (
    target,
    prevstate,
    phone,
    country_code
  ) => {
    if (target.name === "phone" && phone.trim().length) {
      if (regExForPhone.test(target.value)) {
        this.setState({ phone: target.value });
      } else {
        this.setState({ phone: prevstate });
      }
    }
    if (target.name === "country_code" && country_code.trim().length) {
      this.setState({
        country_code: target.value.replace(/[a-zA-Z]/, ""),
      });
    }
  };

  handleOnchangePassword = (target, high_security, passwordValue) => {
    if (target.name === "password") {
      if (high_security) {
        const errMsg = PasswordValidation(target.value);
        this.setState({
          passwordErrorMsg: errMsg,
        });
        if (errMsg) {
          passwordValue = false;
          this.setState({
            passwordErrorMsg: errMsg,
          });
        } else {
          passwordValue = true;
          this.setState({
            passwordErrorMsg: "",
          });
        }
      }
    }
    return passwordValue;
  };

  handleCheckBox = () => {
    console.log("do_not_allow_login before:::", this.state.do_not_allow_login);

    this.setState({ do_not_allow_login: !this.state.do_not_allow_login });

    console.log("do_not_allow_login after:::", this.state.do_not_allow_login);
  };

  handleSubmit = async () => {
    const {
      suite_id,
      parking_spot,
      permits_allowed,
      username,
      first_name,
      last_name,
      country_code,
      phone,
      email,
      do_not_allow_login,
      password,
      user_type,
      ResidentId,
      phone_options,
      deleted_phone_id,
    } = this.state;

    const Obj = {
      suite_id,
      parking_spot,
      permits_allowed,
      username,
      first_name,
      last_name,
      country_code,
      phone,
      email,
      do_not_allow_login,
      password,
      user_type,
      property_id: this.state.property?.id,
      old_data: this.props.editedResident,
      phone_options,
      deleted_phone_id,
    };
    console.log("Obj onedit::::", Obj.deleted_phone_id);
    await this.props.edit_resident(ResidentId, Obj);
    if (this.props.api_response) {
      this.setState(
        {
          show_alert: true,
          api_success_message: this.props.api_success_message,
        },
        () => {
          setTimeout(() => {
            this.setState({ show_alert: false });
            routing_using_history("/units");
          }, 4000);
        }
      );
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  checkAllValidations = (
    phone,
    username,
    first_name,
    last_name,
    permits_allowed,
    isValidPhone,
    passwordValue
  ) => {
    if (
      phone.length &&
      phone &&
      username &&
      first_name &&
      last_name &&
      permits_allowed &&
      isValidPhone &&
      passwordValue &&
      this.isMultiplePhoneValid()
    ) {
      this.setState({ isFormValid: true });
    } else {
      this.setState({ isFormValid: false });
    }
  };

  handleBack = () => {
    routing_using_history(`/units`);
  };

  TogglePasswordVisibility = () => {
    this.setState({
      passwordVisible: !this.state.passwordVisible,
    });
  };

  render() {
    const {
      suite_id,
      parking_spot,
      permits_allowed,
      username,
      first_name,
      last_name,
      country_code,
      phone,
      email,
      do_not_allow_login,
      password,
      // wrongEmail,
      // wrongNumber,
      // validParkingSpot,
      validFirstName,
      validLastName,
      validPhone,
      // validEmail,
      validPermitAllowed,
      validUser,
      isFormValid,
      show_alert,
      api_success_message,
      show_error,
      passwordErrorMsg,
      passwordVisible,
      country_code_list,
      phone_options,
      phoneErrorMessage,
    } = this.state;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  <Card.Title as="h4">Edit Unit</Card.Title>
                  <p className="card-category"></p>
                </Card.Header>
                <Card.Body className="pos-rel-overflow-hide">
                  {/* <h4 className="mt-0 mb-2">User Profile Settings</h4> */}
                  <Row>
                    <Col lg="3" className="pr-md-1">
                      <Form.Group>
                        <label>Unit Id</label>
                        <Form.Control
                          name="suite_id"
                          value={suite_id}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="3" className="pr-md-1">
                      <Form.Group>
                        <label>
                          Number of Permits Allowed
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="4"
                          type="text"
                          name="permits_allowed"
                          value={permits_allowed}
                          autoComplete="off"
                          onChange={this.handleChange}
                          required
                        />
                        {validation_message(
                          permits_allowed,
                          "Number of Permit",
                          validPermitAllowed
                        )}
                      </Form.Group>
                    </Col>
                    <Col lg="3" className="pr-md-1">
                      <Form.Group>
                        <label>
                          Username
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="2100user"
                          type="text"
                          name="username"
                          value={username}
                          autoComplete="off"
                          onChange={this.handleChange}
                          required
                        />
                        {validation_message(username, "Username", validUser)}
                      </Form.Group>
                    </Col>

                    <Col md="3">
                      <Form.Group>
                        <label>Password</label>
                        <div className="input-mask-btn">
                          <Form.Control
                            type={passwordVisible ? "text" : "password"}
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={this.handleChange}
                            autoComplete="new-password"
                          />
                          <button
                            className="mask-password"
                            type="button"
                            onClick={this.TogglePasswordVisibility}
                          >
                            <i
                              className={`fas ${
                                passwordVisible ? "fa-eye" : "fa-eye-slash"
                              }`}
                            />
                          </button>
                        </div>
                        <div
                          style={{ color: "red", fontSize: 13 }}
                          dangerouslySetInnerHTML={{ __html: passwordErrorMsg }}
                        ></div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="3" className="pr-md-1">
                      <Form.Group>
                        <label>
                          First Name
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="John"
                          type="text"
                          name="first_name"
                          value={first_name}
                          autoComplete="off"
                          onChange={this.handleChange}
                          required
                        ></Form.Control>
                        {validation_message(
                          first_name,
                          "First Name",
                          validFirstName
                        )}
                      </Form.Group>
                    </Col>
                    <Col lg="3" className="pr-md-1">
                      <Form.Group>
                        <label>
                          Last Name
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="Smith"
                          type="text"
                          name="last_name"
                          value={last_name}
                          autoComplete="off"
                          onChange={this.handleChange}
                          required
                        />
                        {validation_message(
                          last_name,
                          "Last Name",
                          validLastName
                        )}
                      </Form.Group>
                    </Col>

                    <Col lg="3">
                      <Form.Group>
                        <label>Notes</label>
                        <Form.Control
                          placeholder="20"
                          type="text"
                          name="parking_spot"
                          value={parking_spot}
                          autoComplete="off"
                          onChange={this.handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="3">
                      <Form.Group>
                        <label>
                          Email Address
                          {/* <span className="asterisk">*</span> */}
                        </label>
                        <Form.Control
                          placeholder="example@gmail.com"
                          type="text"
                          name="email"
                          value={email}
                          autoComplete="off"
                          onChange={this.handleChange}
                          disabled
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="2">
                      <Form.Group>
                        <label>Country Code</label>
                        {/* <Form.Control
                          placeholder="Country code"
                          type="text"
                          name="country_code"
                          value={country_code}
                          autoComplete="off"
                          onChange={this.handleChange}
                          required
                        /> */}
                        <Form.Control
                          as="select"
                          name="country_code"
                          onChange={this.handleChange}
                          value={country_code}
                          required
                        >
                          {country_code_list ? (
                            <>
                              {country_code_list.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.text}
                                </option>
                              ))}
                            </>
                          ) : null}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col lg="3">
                      <Form.Group>
                        <label>
                          Phone
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="2145602323"
                          type="text"
                          name="phone"
                          value={phone}
                          autoComplete="off"
                          onChange={this.handleChange}
                          required
                        />
                        {validation_message(phone, "Phone Number", validPhone)}
                        <span className="help-block">
                          {this.state.phoneErrorMessage}
                        </span>
                      </Form.Group>
                    </Col>
                    <Col md="2">
                      <Button
                        size="sm"
                        className="ml-3 mt-4"
                        disabled={
                          phone_options?.length > 9 ||
                          phoneErrorMessage.trim().length !== 0 ||
                          phone.trim().length === 0 ||
                          !this.isMultiplePhoneValid()
                        }
                        onClick={this.handleAddPhoneOptions}
                      >
                        <i className="fas fa-plus-circle"></i>
                      </Button>
                    </Col>
                    <Col md="5"></Col>
                  </Row>
                  {phone_options &&
                    typeof phone_options === "object" &&
                    Array.isArray(phone_options) &&
                    phone_options.map((option, index) => {
                      return (
                        <Row key={option?.country_code} className="my-0">
                          <Col className="" md="3">
                            <Form.Group>
                              <Form.Control
                                as="select"
                                name="country_code_options"
                                onChange={(e) =>
                                  this.handlePhoneOptions(
                                    index,
                                    e.target.value,
                                    "country_code_options"
                                  )
                                }
                                value={option?.country_code}
                                required
                              >
                                {country_code_list ? (
                                  <>
                                    {country_code_list.map((item) => (
                                      <option
                                        key={item.text}
                                        value={item.value}
                                      >
                                        {item.text}
                                      </option>
                                    ))}
                                  </>
                                ) : null}
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col className="" md="3">
                            <Form.Group className="p-0 m-1">
                              {/* <Form.Label>Option {index + 1}</Form.Label> */}
                              {/* <span className="asterisk">*</span> */}
                              <Form.Control
                                placeholder="Phone Number"
                                type="text"
                                name="phone_number_options"
                                value={option?.phone}
                                // onBlur={(e) => e.target.value.trim() === "" && removeNoteOption(index)}
                                onChange={(e) =>
                                  this.handlePhoneOptions(
                                    index,
                                    e.target.value,
                                    "phone_number_options"
                                  )
                                }
                                maxLength="10"
                                autoComplete="off"
                              />
                            </Form.Group>
                          </Col>
                          <Col md="3" className="mt-2">
                            <Button
                              size="sm"
                              className="ml-2"
                              onClick={() => this.removePhoneOption(index)}
                            >
                              <i className="fas fa-minus"></i>
                            </Button>
                          </Col>
                        </Row>
                      );
                    })}

                  <Row>
                    <Col lg="9">
                      <p className="blue">
                        **Note: The unit will receive an email to set their
                        password.
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6" className="mt-4">
                      <label className="fancy-checkbox">
                        <input
                          type="checkbox"
                          name={"do_not_allow_login"}
                          checked={do_not_allow_login}
                          onChange={this.handleCheckBox}
                          className="custom-control-input"
                          id="do_not_allow_login1"
                        ></input>
                        <span>
                          <i></i>Do not allow login
                        </span>
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" className="text-right">
                      <Button
                        className="btn-fill"
                        type="button"
                        variant="danger"
                        onClick={this.handleBack}
                      >
                        Back
                      </Button>
                      <Button
                        className="btn-fill ml-2"
                        type="button"
                        variant="info"
                        disabled={!isFormValid}
                        onClick={this.handleSubmit}
                      >
                        Submit Changes
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        {show_alert && (
          <CustomContentAlert
            delay={4000}
            message={api_success_message}
            // message={"Unit edited succesfully"}
            className="toast-success"
          />
        )}
        {show_error && (
          <CustomContentAlert
            delay={5000}
            message={this.state.api_error_message}
            className="toast-error"
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({
  ResidenDetails,
  APIResponseDetails,
  UserProfileDetails,
  Logindetails,
}) => {
  const { editedResident } = ResidenDetails;
  const { property } = UserProfileDetails;
  const { api_response, api_success_message, api_error_message } =
    APIResponseDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    editedResident,
    api_response,
    api_success_message,
    api_error_message,
    property,
    main_body,
  };
};

const mapStateToDispatch = {
  select_edit_resident: ResidentsActions.select_edit_resident,
  edit_resident: ResidentsActions.edit_resident,
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStateToProps, mapStateToDispatch)(EditResident);
